import React, { useEffect, useState, useContext } from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Input,
  Label,
  Button,
  FormGroup,
  Spinner,
} from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { useParams, useNavigate } from "react-router-dom";

import swal from "sweetalert";
// import "../../../../../src/layouts/assets/scss/pages/users.scss";

import {
  Createtransportersave,
  Get_RoleList,
  _BulkUpload,
  _Get,
  _GetList,
  _PostSave,
  _Put,
} from "../../ApiEndPoint/ApiCalling";
// import "../../../../assets/scss/pages/users.scss";
import UserContext from "../../context/Context";

import {
  Bulk_Upload_transporter,
  Bulk_Upate_transporterUpload,
  GST_Verification_Api,
  Image_URL,
  Pan_Verification_API,
  Pan_Verification_key,
  Update_TransporterByID,
  View_TransporterByID,
  country_state_City_List,
} from "../../ApiEndPoint/Api";
import { FaUpload } from "react-icons/fa";

const CreateTransporter = () => {
  const [Country_State_city, setCountry_State_city] = useState([]);
  const [BulkUpload, setBulkUpload] = useState(false);
  const [Image, setImage] = useState({});
  const [Loader, setLoader] = useState(false);
  const [BulkImport, setBulkImport] = useState(null);
  const [Cities, setCities] = useState([]);
  const [formData, setFormData] = useState({});
  const [transporterType, settransporterType] = useState("Add");
  const [index, setindex] = useState("");
  const [error, setError] = useState("");
  const [Loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState([
    {
      BMName: "",
      address: "",
      contactNumber: "",
      gstNumber: "",
      contactNumber: "",
      otherContactNumber: "",
      pincode: "",
      city: "",
      state: "",
    },
  ]);

  const Context = useContext(UserContext);
  const navigate = useNavigate();
  let Params = useParams();

  // start
  let handleChange = (i, e) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
  };
  let handleChangePhone = (i, phone) => {
    let newFormValues = [...formValues];
    newFormValues[i]["contactNumber"] = phone;
    setFormValues(newFormValues);
  };

  let addFormFields = () => {
    setFormValues([
      ...formValues,
      {
        BMName: "",
        address: "",
        contactNumber: "",
        gstNumber: "",
        contactNumber: "",
        otherContactNumber: "",
        pincode: "",
        city: "",
        state: "",
      },
    ]);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  // end add  more

  const handleFileChange = (e, type, i) => {
    const { name, value, checked } = e.target;
    let allimages = Array.from(e.target.files);
    setindex(i);
    setFormData({
      ...formData,
      [name]: allimages,
    });
  };

  const handleInputChange = (e, type, i) => {
    const { name, value, checked } = e.target;
    setindex(i);
    if (type == "checkbox") {
      if (checked) {
        setFormData({
          ...formData,
          [name]: checked,
        });
      } else {
        setFormData({
          ...formData,
          [name]: checked,
        });
      }
    } else {
      if (type == "number") {
        if (/^\d{0,10}$/.test(value)) {
          setFormData({
            ...formData,
            [name]: value,
          });
          setError("");
        }
      } else if (type == "file") {
        if (e.target.files) {
          setFormData({
            ...formData,
            [name]: e.target.files[0],
          });
        }
      } else {
        if (value.length <= 10) {
          setFormData({
            ...formData,
            [name]: value,
          });

          setError("");
        } else {
          setFormData({
            ...formData,
            [name]: value,
          });
        }
      }
    }
  };
  useEffect(() => {
    _GetList(country_state_City_List)
      .then((res) => {
        setCountry_State_city(res);
      })
      .catch((err) => {
        console.log(err);
      });
    if (Params?.id == 0) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const date = new Date(position.timestamp);
            const CurentTime = date.toLocaleString();
            formData.geotagging = `${position.coords.latitude},${position.coords.longitude}`;
          },
          (error) => {
            swal(`Error: ${error}`);
          },
          { timeout: 10000, enableHighAccuracy: true }
        );
      } else {
        swal(`Error: Geolocation not found`);
      }
    }
  }, []);
  const handleVerifyCompanyPan = async (inputPan) => {
    let payload = {
      api_key: Pan_Verification_key,
      pan: inputPan,
    };
    await _PostSave(Pan_Verification_API, payload)
      .then((res) => {
        console.log(res);
        if (res?.flag) {
          setFormData({
            ...formData,
            ["comPanNo"]: inputPan,
            ["IsValid_comPanNo"]: true,
          });
          swal("success", "Pan Card Verified with GST");
        } else {
          setFormData({
            ...formData,
            ["comPanNo"]: inputPan,
            ["IsValid_comPanNo"]: false,
          });
          swal("Error", "Pan Card notVerified with GST");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    let userdata = JSON.parse(localStorage.getItem("userData"));
    if (Params?.id == 0) {
      Get_RoleList(userdata?._id, userdata?.database)
        .then((res) => {
          let ShowList = res?.Role?.filter((item, i) =>
            item?.roleName?.toLowerCase()?.includes("transporter")
          );

          setFormData({
            ...formData,
            ["rolename"]: ShowList[0]?._id,
            ["database"]: userdata?.database,
          });
        })
        .catch((err) => {
          console.log(err);
          swal("Roles List Not found");
        });
    }
  }, []);

  useEffect(() => {
    if (Params?.id == 0) {
      settransporterType("Add");
    } else {
      settransporterType("Edit");

      _Get(View_TransporterByID, Params?.id)
        .then((res) => {
          let transporter = res?.Transporter;
          transporter["rolename"] = transporter?.rolename?._id;
          setFormValues(transporter?.serviceArea);
          setFormData(transporter);

        })
        .catch((err) => {
          console.log(err.response);
        });
    }
  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();

    setLoader(true);
    let userData = JSON.parse(localStorage.getItem("userData"));

    if (formData?.serviceArea) {
      delete formData?.serviceArea;
    }
    if (formData?.image) {
      delete formData?.image;
    }
    if (BulkImport !== null || BulkImport != undefined) {
      let formdata = new FormData();
      formdata.append("file", BulkImport);
      formdata.append("database", userData?.database);
      setLoader(true);
      if (formData?.UploadStatus == "Update") {
        let URl = `${Bulk_Upate_transporterUpload}/${userData?.database}`;
        await _BulkUpload(URl, formdata)
          .then((res) => {
            if (res.status) {
              setLoading(false);
              swal('Details updated successfully')

            }
            else {
              setLoading(false);
              swal('Error in Updating Details')

            }
            navigate(-1);
            // swal(`${res?.message}`);
          })
          .catch((err) => {
            setLoading(false);
            console.log(err.response);
            swal("Something Went Wrong");
          });
      } else if (formData?.UploadStatus == "New Upload") {
        let URl = `${Bulk_Upload_transporter}/${userData?.database}`;
        await _BulkUpload(URl, formdata)
          .then((res) => {
            if (res.status) {
              swal('Transporter added successfully')
            }
            else {
              swal('Error in adding Transporter')

            }
            setLoader(false);
            // swal(`${res?.message}`);
          })
          .catch((err) => {
            console.log(err);
            setLoader(false);

            swal("Something Went Wrong");
          });
      } else {
        swal("error", "Choose Type of Upload", "error");
      }
    } else {
      let formdata = new FormData();

      for (const [key, value] of Object.entries(formData)) {
        formdata.append(`${key}`, `${value}`);
        console.log(key, value);
      }
formdata.append("database", userData?.database);
      if (formValues?.length) {
        formdata.append("serviceArea", JSON.stringify(formValues));
      }


      if (Image !== null || Image !== undefined) {
        formdata.append("file", Image);
      }

      formdata.forEach((value, key) => {
        console.log(key, value);
      });

      if (error) {
        // swal("Error occured while Entering Details");
      } else {
       
        if (!Params?.id || Params?.id === "0") {
  console.log("CREATE API HIT");
  Createtransportersave(formdata)
    .then((res) => {
      console.log("Create Response:", res);
      setLoader(false);

      if (res?.status) {
        swal("Transporter Created Successfully");
        navigate(-1);
      } else {
        swal("Error in creating Transporter");
      }
    })
    .catch((err) => {
      setLoader(false);
      console.log("Create Error:", err?.response || err);
      swal("Please Fill correct details");
    });
} else {
          _Put(Update_TransporterByID, Params?.id, formdata)
            .then((res) => {
              console.log(res);
              setLoader(false);

              if (res.status) {
                navigate(-1);
                swal("Transporter Updated Successfully");
              }
            })
            .catch((err) => {
              setLoader(false);

              console.log(err);
            });
        }
      }
    }
  };
  const onSelect1 = (selectedList, selectedItem) => {
    setCities(selectedList);
    console.log(selectedList);
  };
  const onRemove1 = (selectedList, selectedItem) => {
    console.log(selectedList);
    setCities(selectedList);
  };
  useEffect(() => {
    console.log(formData);
    // console.log(Image);
    console.log(formValues);
  }, [formValues, formData]);
  const handleChangeBulk = (e) => {
    setFormData({
      ...formData,
      ["UploadStatus"]: e.target.value,
    });
  };
return (
  <div>
    <Card>
      {/* TOP HEADER */}
      <Row className="m-2 align-items-center">
        {/* LEFT SIDE - NO HEADING */}

        {/* RIGHT SIDE BUTTONS */}
        <Col
          xs="12"
          className="d-flex justify-content-end align-items-center gap-2"
        >
          {Params?.id === "0" && (
            <>
              {!BulkUpload ? (
                <Button
                  color="primary"
                  type="button"
                  onClick={() => setBulkUpload(true)}
                >
                  Bulk Upload
                </Button>
              ) : (
                <Button
                  color="primary"
                  type="button"
                  onClick={() => setBulkUpload(false)}
                >
                  Back
                </Button>
              )}
            </>
          )}

          {/* Back button only in normal form */}
          {!BulkUpload && (
            <Button
              color="primary"
              type="button"
              onClick={() => navigate("/users?view=transporter")}
            >
              Back
            </Button>
          )}
        </Col>
      </Row>

      <CardBody>
        <Form className="m-1" onSubmit={submitHandler}>

          {/* ================= BULK UPLOAD ================= */}
          {BulkUpload ? (
            <>
              <Row className="mb-4">
                <Col
                  xs="12"
                  className="d-flex justify-content-center align-items-center"
                >
                  <Label className="mb-0 mr-3">
                    Choose Type of Upload{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Label>

                  <div
                    className="form-label-group"
                    onChange={handleChangeBulk}
                  >
                    <input
                      required
                      checked={formData?.UploadStatus === "New Upload"}
                      style={{ marginRight: "5px" }}
                      type="radio"
                      name="UploadStatus"
                      value="New Upload"
                    />

                    <span style={{ marginRight: "25px" }}>
                      New Upload
                    </span>

                    <input
                      required
                      checked={formData?.UploadStatus === "Update"}
                      style={{ marginRight: "5px" }}
                      type="radio"
                      name="UploadStatus"
                      value="Update"
                    />

                    <span>Update</span>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col
                  xs="12"
                  className="d-flex justify-content-center"
                >
                  <div className="parent">
                    <div className="file-upload mb-3">
                      <FaUpload
                        color="green"
                        size={50}
                      />

                      <p>Click box to upload</p>

                      <input
                        required
                        type="file"
                        name="file"
                        onChange={(e) => {
                          setBulkImport(e.target.files[0]);
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col
                  xs="12"
                  className="d-flex justify-content-center"
                >
                  {Loader ? (
                    <Spinner>
                      Loading...
                    </Spinner>
                  ) : (
                    <Button
                      color="primary"
                      type="submit"
                      className="mt-2"
                    >
                      Import
                    </Button>
                  )}
                </Col>
              </Row>
            </>
          ) : (

            /* ================= NORMAL FORM ================= */
            <>
              {/* TRANSPORTER DETAILS */}
              <Row>
                <Col
                  xs="12"
                  className="mb-3"
                >
                  <CardBody className="userRegiBody">

                    {/* HEADING REMOVED */}

                    <Row>

                      {/* Transporter Name */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            Transporter Name
                          </Label>

                          <Input
                            className="form-control"
                            placeholder="Transporter Name"
                            type="text"
                            name="companyName"
                            value={formData?.companyName || ""}
                            onChange={(e) => {
                              const inputValue =
                                e.target.value;

                              const filteredValue =
                                inputValue.replace(/\s/g, "");

                              setFormData({
                                ...formData,
                                id: filteredValue,
                                companyName: inputValue,
                              });
                            }}
                          />
                        </FormGroup>
                      </Col>

                      {/* Incharge Name */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            Incharge Name{" "}
                            <span style={{ color: "red" }}>
                              *
                            </span>
                          </Label>

                          <Input
                            required
                            placeholder="Enter Incharge Name"
                            type="text"
                            name="name"
                            value={formData?.name || ""}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>

                     
                      <Col lg="3" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            Contact Number{" "}
                            <span style={{ color: "red" }}>
                              *
                            </span>
                          </Label>

                          <PhoneInput
                            country="in"
                            inputClass="myphoneinput"
                            countryCodeEditable={false}
                            name="contactNumber"
                            value={
                              formData?.contactNumber || ""
                            }
                            onChange={(phone) => {
                              setFormData({
                                ...formData,
                                contactNumber: phone,
                              });
                            }}
                          />
                        </FormGroup>
                      </Col>

                      {/* Pin Code */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            Pin Code Number{" "}
                            <span style={{ color: "red" }}>
                              *
                            </span>
                          </Label>

                          <Input
                            required
                            type="number"
                            placeholder="Enter Pin Code"
                            name="pincode"
                            value={
                              formData?.pincode || ""
                            }
                            onChange={(e) => {
                              const value =
                                e.target.value;

                              const selectedCity =
                                Country_State_city?.find(
                                  (ele) =>
                                    String(
                                      ele?.Pincode
                                    ) === String(value)
                                );

                              if (selectedCity) {
                                setFormData({
                                  ...formData,
                                  state:
                                    selectedCity?.StateName,
                                  city:
                                    selectedCity?.District,
                                  pincode: Number(value),
                                  transporterDetail: 0,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  pincode: Number(value),
                                  transporterDetail: 0,
                                });
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>

                      {/* City */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>City</Label>

                          <Input
                            readOnly
                            placeholder="City name"
                            type="text"
                            value={formData?.city || ""}
                          />
                        </FormGroup>
                      </Col>

                      {/* State */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>State</Label>

                          <Input
                            readOnly
                            placeholder="State name"
                            type="text"
                            value={formData?.state || ""}
                          />
                        </FormGroup>
                      </Col>

                      {/* GST */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            GST Number{" "}
                            <span style={{ color: "red" }}>
                              *
                            </span>
                          </Label>

                          <Input
                            type="text"
                            required
                            minLength={15}
                            maxLength={15}
                            name="gstNumber"
                            placeholder="Enter GST Number"
                            value={
                              formData?.gstNumber || ""
                            }
                            onChange={(e) => {
                              const value =
                                e.target.value.toUpperCase();

                              setFormData({
                                ...formData,
                                gstNumber: value,
                              });

                              if (value.length === 15) {
                                setLoader(true);

                                _Get(
                                  GST_Verification_Api,
                                  value
                                )
                                  .then((res) => {
                                    const address =
                                      res?.data?.pradr?.adr ||
                                      "";

                                    const parts =
                                      address.split(",");

                                    const part1 =
                                      parts[0]?.trim() || "";

                                    const part2 =
                                      parts
                                        .slice(1)
                                        .join(",")
                                        .trim();

                                    if (res?.flag) {
                                      setFormData({
                                        ...formData,
                                        companyName:
                                          res?.data?.tradeNam,
                                        address1: part1,
                                        address2: part2,
                                        gstNumber: value,
                                        id: value.slice(2, 12),
                                      });
                                    } else {
                                      setFormData({
                                        ...formData,
                                        companyName: "",
                                        address1: "",
                                        address2: "",
                                        gstNumber: value,
                                        id: value.slice(2, 12),
                                      });
                                    }

                                    setLoader(false);
                                  })
                                  .catch((err) => {
                                    setLoader(false);

                                    console.log(err);

                                    setFormData({
                                      ...formData,
                                      gstNumber: value,
                                      id: value.slice(2, 12),
                                    });

                                    swal(
                                      "error",
                                      "Something went wrong"
                                    );
                                  });
                              }
                            }}
                          />

                          {Loader && (
                            <small
                              style={{ color: "red" }}
                            >
                              Getting GST Information...
                            </small>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Address */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            Address{" "}
                            <span style={{ color: "red" }}>
                              *
                            </span>
                          </Label>

                          <Input
                            required
                            placeholder="Address"
                            type="text"
                            name="address1"
                            value={
                              formData?.address1 || ""
                            }
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>

                      {/* Opening Balance */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            Opening Balance{" "}
                            <span style={{ color: "red" }}>
                              *
                            </span>
                          </Label>

                          <Input
                            required
                            type="number"
                            name="OpeningBalance"
                            placeholder="Opening Balance"
                            value={
                              formData?.OpeningBalance || ""
                            }
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>

                      {/* Balance Type */}
                      <Col lg="2" md="4" sm="6" xs="12">
                        <FormGroup>
                          <Label>
                            O/P Balance Type{" "}
                            <span style={{ color: "red" }}>
                              *
                            </span>
                          </Label>

                          <Input
                            required
                            type="select"
                            name="Type"
                            value={
                              formData?.Type || ""
                            }
                            onChange={handleInputChange}
                          >
                            <option value="">
                              ---- Select Type ----
                            </option>

                            <option value="debit">
                              Dr
                            </option>

                            <option value="credit">
                              Cr
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>

                    </Row>
                  </CardBody>
                </Col>
              </Row>

              {/* ================= SERVICE LOCATION ================= */}

              {formValues.map((element, index) => (
                <React.Fragment key={index}>

                  <Row>
                    <Col xs="12">
                      <div className="d-flex justify-content-center">
                        <h3>
                          Service Location - ({index + 1})
                        </h3>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-2">

                    {/* Branch Manager */}
                    <Col lg="2" md="4" sm="6" xs="12">
                      <FormGroup>
                        <Label>
                          Branch Manager Name
                        </Label>

                        <Input
                          type="text"
                          placeholder="Branch Manager Name"
                          name="BMName"
                          value={
                            element.BMName || ""
                          }
                          onChange={(e) =>
                            handleChange(index, e)
                          }
                        />
                      </FormGroup>
                    </Col>

                    {/* Mobile */}
                    <Col lg="3" md="4" sm="6" xs="12">
                      <FormGroup>
                        <Label>
                          Mobile No.{" "}
                          <span style={{ color: "red" }}>
                            *
                          </span>
                        </Label>

                        <PhoneInput
                          required
                          country="in"
                          inputClass="myphoneinput"
                          countryCodeEditable={false}
                          value={
                            element.contactNumber || ""
                          }
                          onChange={(phone) => {
                            const newFormValues =
                              [...formValues];

                            newFormValues[index] = {
                              ...newFormValues[index],
                              contactNumber: phone,
                            };

                            setFormValues(
                              newFormValues
                            );
                          }}
                        />
                      </FormGroup>
                    </Col>

                    {/* Pin */}
                    <Col lg="2" md="4" sm="6" xs="12">
                      <FormGroup>
                        <Label>
                          Pin Code{" "}
                          <span style={{ color: "red" }}>
                            *
                          </span>
                        </Label>

                        <Input
                          required
                          type="number"
                          placeholder="Enter Pin Code"
                          name="pincode"
                          value={
                            element.pincode || ""
                          }
                          onChange={(e) => {
                            const value =
                              e.target.value;

                            const selectedCity =
                              Country_State_city?.find(
                                (ele) =>
                                  String(
                                    ele?.Pincode
                                  ) === String(value)
                              );

                            const newFormValues =
                              [...formValues];

                            newFormValues[index] = {
                              ...newFormValues[index],
                              pincode: Number(value),
                              ...(selectedCity
                                ? {
                                    state:
                                      selectedCity.StateName,
                                    city:
                                      selectedCity.District,
                                  }
                                : {}),
                            };

                            setFormValues(
                              newFormValues
                            );
                          }}
                        />
                      </FormGroup>
                    </Col>

                    {/* Branch Location */}
                    <Col lg="2" md="4" sm="6" xs="12">
                      <FormGroup>
                        <Label>
                          Branch Location
                        </Label>

                        <Input
                          readOnly
                          placeholder="City name"
                          type="text"
                          value={
                            element.city || ""
                          }
                        />
                      </FormGroup>
                    </Col>

                    {/* Address */}
                    <Col lg="2" md="4" sm="6" xs="12">
                      <FormGroup>
                        <Label>Address</Label>

                        <Input
                          type="text"
                          placeholder="Branch Address"
                          name="address"
                          value={
                            element.address || ""
                          }
                          onChange={(e) =>
                            handleChange(index, e)
                          }
                        />
                      </FormGroup>
                    </Col>

                    {/* Remove */}
                    <Col
                      lg="2"
                      md="4"
                      sm="6"
                      xs="12"
                      className="d-flex align-items-center"
                    >
                      {index > 0 && (
                        <Button
                          color="danger"
                          type="button"
                          onClick={() =>
                            removeFormFields(index)
                          }
                        >
                          Remove
                        </Button>
                      )}
                    </Col>

                  </Row>
                </React.Fragment>
              ))}

              {/* ADD SERVICE LOCATION */}
              <Row>
                <Col
                  xs="12"
                  className="d-flex justify-content-end"
                >
                  <Button
                    color="primary"
                    type="button"
                    className="mt-2"
                    onClick={addFormFields}
                  >
                    Add
                  </Button>
                </Col>
              </Row>

              {/* ================= BOTTOM ================= */}

              <Row className="mt-4 align-items-center">

                {/* Image */}
                <Col lg="2" md="4" sm="12">
                  <FormGroup>
                    <Label>
                      Image
                    </Label>

                    <div className="parent">
                      <div className="file-upload">
                        <FaUpload
                          color="green"
                          size={35}
                        />

                        <p>
                          Click box to upload
                        </p>

                        <input
                          type="file"
                          name="Photo"
                          onChange={(e) => {
                            const file =
                              e.target.files[0];

                            setImage(file);

                            if (file) {
                              const reader =
                                new FileReader();

                              reader.onload = (event) => {
                                setFormData({
                                  ...formData,
                                  PhotoUrl:
                                    event.target.result,
                                });
                              };

                              reader.readAsDataURL(
                                file
                              );
                            }
                          }}
                        />
                      </div>
                    </div>

                    {formData?.PhotoUrl && (
                      <img
                        style={{
                          borderRadius: "8px",
                          marginTop: "10px",
                        }}
                        src={formData.PhotoUrl}
                        height={100}
                        width={120}
                        alt="preview"
                      />
                    )}

                    {formData?.image && (
                      <img
                        style={{
                          borderRadius: "8px",
                          marginTop: "10px",
                        }}
                        src={`${Image_URL}/Images/${formData.image}`}
                        height={100}
                        width={120}
                        alt="existing"
                      />
                    )}
                  </FormGroup>
                </Col>

                {/* Status */}
                <Col lg="4" md="5" sm="12">
                  <FormGroup>
                    <Label>
                      Status
                    </Label>

                    <div className="form-label-group">
                      <input
                        checked={
                          formData?.status === "Active"
                        }
                        required
                        type="radio"
                        name="status"
                        value="Active"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            status: e.target.value,
                          })
                        }
                      />

                      <span
                        style={{
                          marginRight: "25px",
                          marginLeft: "5px",
                        }}
                      >
                        Active
                      </span>

                      <input
                        checked={
                          formData?.status === "Deactive"
                        }
                        required
                        type="radio"
                        name="status"
                        value="Deactive"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            status: e.target.value,
                          })
                        }
                      />

                      <span style={{ marginLeft: "5px" }}>
                        Deactive
                      </span>
                    </div>
                  </FormGroup>
                </Col>

                {/* Submit */}
                <Col
                  lg="6"
                  md="3"
                  sm="12"
                  className="d-flex justify-content-end align-items-center"
                >
                  {Loader ? (
                    <Spinner>
                      Loading...
                    </Spinner>
                  ) : (
                    <Button
                      color="primary"
                      type="submit"
                      className="mt-2"
                    >
                      Submit
                    </Button>
                  )}
                </Col>

              </Row>
            </>
          )}
        </Form>
      </CardBody>
    </Card>
  </div>
);
};
export default CreateTransporter;